import { webviewManager } from '@pay-mono-web/webview-manager';
import { StrictMode, Suspense, lazy } from 'react';
import * as ReactDOM from 'react-dom/client';
import { environment } from './environments';

const App = lazy(() => import('./app'));
const QrCodePage = lazy(() => import('./pages/qr-code'));

webviewManager.install({
  liff: {
    init: {
      liffId: environment.liffId ?? '',
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

(async () => {
  if (webviewManager.isLIFF) {
    await window.liff.ready;

    // handle LIFF hback to adjust the history stack
    const searchParams = new URLSearchParams(location.search);
    const liffHBack = searchParams.get('liff.hback');

    if (liffHBack !== null && /\d+/.test(liffHBack)) {
      const hback = parseInt(liffHBack);

      if (hback >= 2) {
        window.history.go(hback * -1 + 1);
        return;
      }
    }
  }

  // Initialize Sentry for error monitoring
  if (process.env.NX_SENTRY_DSN) {
    try {
      await import('./sentry');
      console.info('Sentry initialized.');
    } catch (error) {
      console.error('Failed to initialize Sentry:', error);
    }
  }

  root.render(
    <Suspense fallback={null}>
      {environment.stage !== 'alpha' && webviewManager.isWebBrowser ? (
        <QrCodePage />
      ) : (
        <App />
      )}
    </Suspense>, // FIXME: Disable strict mode for `usePurchaseItems` throw error because empty item data.
  );
})();
